<script>
    // import {flow_info, flow_stack} from './stores.js';
    import{user_data} from './stores.js';
    import { onMount } from "svelte";
    import Dtemplate from "./components/detailedtemplate.svelte";
    import Progresscomponent from "./components/progresscomponent.svelte";
    // import Listcomponent from './components/listcomponent.svelte';
    import Listcomponent from './components/listcomponent.svelte';
    export let listdata = [
        {s: true, t: "In 5 years", cbf:()=>{$user_data.whenpayoffmortgage = "In 5 years";}},
        {s: true, t: "In 10 years", cbf:()=>{$user_data.whenpayoffmortgage = "In 10 years";}},
        {s: true, t: "In 15 years", cbf:()=>{$user_data.whenpayoffmortgage = "In 15 years";}},
        {s: true, t: "In 20 years", cbf:()=>{$user_data.whenpayoffmortgage = "In 20 years";}},
    ];

    onMount(async() => {

    });

</script>

<Dtemplate
progress_mobile_version={true}
show_icon_card={true}
>
    <Progresscomponent 
    title="When do you want to pay off your mortgage?"
    show_next_button={false}
    >
    <Listcomponent
        bind:listdata={listdata}
    />
    </Progresscomponent>
</Dtemplate>

<style>

</style>